import { getThemeName } from '@lib/utils';

export const DEFAULT_THEME = getThemeName();

export const MOBILE_BREAKPOINT = 640;
